import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Btn, Input } from '../../components/UI';
import api from '../../utils/api';

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      const { data } = await api.post('/api/auth/admin/login', { username, password });
      if (data.success) { localStorage.setItem('msreach_admin_token', data.token); navigate('/admin'); }
      else setError(data.message);
    } catch (err) { setError(err.response?.data?.message || 'Invalid credentials'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, padding: 48, width: '100%', maxWidth: 400, textAlign: 'center' }}>
        <div style={{ width: 56, height: 56, background: '#ffd700', borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, margin: '0 auto 20px' }}>🔐</div>
        <span style={{ background: 'rgba(255,215,0,0.1)', color: '#ffd700', padding: '4px 14px', borderRadius: 100, fontSize: 12, fontWeight: 700 }}>Admin Access</span>
        <h1 style={{ fontSize: 22, fontFamily: 'Sora', fontWeight: 700, margin: '16px 0 8px' }}>Admin Login</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 14, marginBottom: 28 }}>Restricted access for administrators only</p>
        {error && <div style={{ background: 'rgba(255,68,68,0.1)', border: '1px solid rgba(255,68,68,0.3)', color: '#ff6b6b', padding: '12px 16px', borderRadius: 8, fontSize: 13, marginBottom: 16, textAlign: 'left' }}>{error}</div>}
        <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
          <Input label="Username" value={username} onChange={e => setUsername(e.target.value)} placeholder="Admin username" required />
          <Input label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Admin password" required />
          <Btn type="submit" disabled={loading} full size="lg" style={{ marginTop: 8 }}>{loading ? 'Signing in...' : 'Admin Sign In'}</Btn>
        </form>
        <div style={{ marginTop: 16 }}><Link to="/login" style={{ fontSize: 13, color: 'var(--text-muted)' }}>← User Login</Link></div>
      </div>
    </div>
  );
}